import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import InterestCalculationType from "@/models/Products/InterestCalculationType";
import InterestDaysInYear from "@/models/Products/InterestDaysInYear";
import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import InterestRateType from "@/models/Products/InterestRateType";
import PeriodType from "@/models/Shared/PeriodType";
import DayOfWeek from "@/models/Shared/DayOfWeek";
import Month from "@/models/Shared/Month";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";
import InterestType from '@/models/Products/InterestType';
import PostedFrequencyType from "@/models/Shared/PostedFrequencyType";
import RepaymentInterestCalculationType from "@/models/Shared/RepaymentInterestCalculationType";

export default class LendingInterestSettings extends BaseProductSettings {
    enabled: boolean = true;
    calculationType: InterestCalculationType = InterestCalculationType.Flat;
    interestType: InterestType = InterestType.Simple;
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 5;
    cumulativeRateValue: number;
    rateFloorValue: number = 2;
    rateCeilingValue: number = 12.5;
    rateSourceId: string;
    rateSourceIdentifier: EntityIdentifier;
    rateChargedPeriodType: PeriodType = PeriodType.Month;
    rateChargedPeriodValue: number = 1;
    accruedPeriodType: PeriodType = PeriodType.Day;
    accruedPeriodValue: number = 1;
    accruedPeriodOnDayOfWeek: DayOfWeek;
    accruedPeriodOnDayOfMonth: number;
    accruedPeriodOnMonth: Month;
    calculatedOnBalanceType: InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType.EndOfDayBalance;
    postedFrequencyType: PostedFrequencyType = PostedFrequencyType.Disbursement;
    accrueAfterMaturity: boolean = false;
    repaymentInterestCalculationType: RepaymentInterestCalculationType = RepaymentInterestCalculationType.RepaymentPeriodocity;
    daysInYearType: InterestDaysInYear = InterestDaysInYear.Actual365;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
}